'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'megaphone';
var width = 512;
var height = 512;
var aliases = [128227];
var unicode = 'f675';
var svgPathData = ['M64 198.6l0 114.8 384 108 0-330.8-384 108z', 'M496 64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16s16-7.2 16-16l0-384zm-48 0c0-17.7 14.3-32 32-32s32 14.3 32 32l0 384c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-10-129.6-36.5c-8.2 44.6-47.4 78.5-94.4 78.5-53 0-96-43-96-96 0-12.1 2.2-23.6 6.3-34.2L62.5 329.6c-4.1 13-16.2 22.4-30.5 22.4-17.7 0-32-14.3-32-32L0 192c0-17.7 14.3-32 32-32 14.3 0 26.5 9.4 30.5 22.4L448 74 448 64zm0 26.6l-384 108 0 114.8 384 108 0-330.8zM149.8 354.1c-3.7 9.2-5.8 19.3-5.8 29.9 0 44.2 35.8 80 80 80 39.7 0 72.6-28.9 78.9-66.8L149.8 354.1zM48 320l0-128c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMegaphone = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;